export const TEST_ID = 'stripeSubscriptionCard';

export const FREE = 'FREE';
